export default __webpack_public_path__ + "static/media/1.dc4e4dd6.png";